import config from '@config'
import { JSONWidgetType as TeaserStandardHorizontalJSONWidgetType } from '@widgets/TeaserStandardHorizontal'

import {
  ExecuteQuery,
  getAureusBatchRecommendations,
  getSectionWithAureusEnvironment,
  Purpose,
  QueryFactory,
} from '..'

interface AureusRecommendationItem extends Record<string, unknown> {
  articleID: string
  filterTeasers: string[]
  teasers: {
    standardHorizontal: TeaserStandardHorizontalJSONWidgetType
  }
  uuid: string
  aureusOfferId: string
}

const {
  publication: { publication },
  aureus: { aureusEnvironment },
} = config

export const queryKey = 'recommended-content'

export const createQuery = (({
  purpose = 'reference',
  contentBlacklist,
  contentId,
}: {
  purpose?: Purpose
  contentBlacklist?: string
  contentId?: string
}) =>
  ({
    [queryKey]: {
      resultsLimit: 8,
      context: {
        section: getSectionWithAureusEnvironment(
          `polaris${publication === 'romandie' ? '-romandie' : ''}-article-popular-widget`,
        ),
        purpose,
        contentBlacklist,
        ...(aureusEnvironment === 'prod' ? { contentId } : {}),
      },
    },
  }) as const) satisfies QueryFactory<typeof queryKey>

export const executeQuery = (async (
  queryOptions: Parameters<typeof createQuery>[0],
  options?: Record<string, unknown>,
) => {
  try {
    const result = (
      await getAureusBatchRecommendations<
        typeof queryKey,
        AureusRecommendationItem
      >(createQuery(queryOptions), options)
    ).results[queryKey]

    if (!Array.isArray(result?.recommendations)) {
      return
    }

    return result.recommendations
  } catch (err) {
    console.error(err)
  }
}) satisfies ExecuteQuery<typeof queryKey>
